import { STRAPI } from 'config/apis'
import { getMenu } from './global'

const publicGetRequest = async ({ endpoint, queryString = '', cacheHours }) => {
  try {
    const req = await fetch(
      `${STRAPI[endpoint]}${queryString}`,
      cacheHours
        ? {
            next: { revalidate: 60 * 60 * cacheHours }
          }
        : {}
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const getTitleByNavRequest = async (name) => {
  const menuReq = await getMenu()
  let items = menuReq
    .filter(({ attributes }) => attributes.title === 'Competició')
    .pop()
  items = items.attributes.children.data
    .filter(({ attributes }) => attributes.title === 'Circuits i Lligues')
    .pop()
  items = items.attributes.children.data
    .filter(({ attributes }) => attributes.title.includes(name))
    .pop()
  return items?.attributes?.title
}

export { publicGetRequest, getTitleByNavRequest }
